import { ArtifactPanelView } from '../../chat/components/ArtifactPanelView';
import { useConvArtifactStore } from './convArtifactStore';

export function ConvArtifactPanel() {
  const artifacts = useConvArtifactStore((s) => s.artifacts);
  const activeIndex = useConvArtifactStore((s) => s.activeIndex);
  const setActiveIndex = useConvArtifactStore((s) => s.setActiveIndex);

  return (
    <ArtifactPanelView
      artifacts={artifacts}
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
      storagePrefix="admin.convArtifactPanel"
    />
  );
}
